

// Navigation.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ isLoggedIn, onLogout }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="bg-blue-600 p-4 flex justify-between items-center">
            {/* Logo */}
            <div className="text-white text-xl font-bold">
                <Link to="/" onClick={() => setIsOpen(false)}>Psychology AI Note Generator</Link>
            </div>

            {/* Hamburger Icon for Mobile */}
            <div className="md:hidden">
                <button onClick={toggleMenu} className="text-white focus:outline-none">
                    {/* Icon: Show '☰' when closed, '×' when open */}
                    {isOpen ? '×' : '☰'}
                </button>
            </div>

            {/* Navigation Links */}
            <ul className={`flex-col md:flex-row md:flex space-x-4 absolute md:static left-0 w-full md:w-auto bg-blue-600 md:bg-transparent transition-transform duration-300 ${isOpen ? 'top-16' : '-top-full'}`}>
                <li className="text-white px-4 py-2 md:py-0">
                    <Link to="/" onClick={toggleMenu}>Home</Link>
                </li>
                {!isLoggedIn ? (
                    <li className="text-white px-4 py-2 md:py-0">
                        <Link to="/sign-in" onClick={toggleMenu}>Sign In</Link>
                    </li>
                ) : (
                    <>
                        <li className="text-white px-4 py-2 md:py-0">
                            <Link to="/note-form" onClick={toggleMenu}>Note Form</Link>
                        </li>
                        <li className="text-white px-4 py-2 md:py-0">
                            <Link to="/logout" className="text-white focus:outline-none" onClick={toggleMenu}>Log
                                Out</Link>
                        </li>
                    </>
                )}
            </ul>
        </nav>
    );
};

export default Navbar;
